import React, { useState, useEffect, useCallback } from 'react'
import { FreshAccountForm } from '../components/FreshAccountForm'
import { Mapping } from '../components/Mapping'
import { Purchase } from '../components/Purchase'
import { Navbar } from '../components/Navbar'
import { useGetMapping } from '../hooks/useGetMapping'
import { useGetAccount } from '../hooks/useGetAccount'
import { mondayService } from '../services/mondayService'
import { ErrorMessage } from '../components/ErrorMessage'
const { Loader } = require('monday-ui-react-core')

interface HomeProps {
  monday: any
  mondayError: boolean
  setMondayError: React.Dispatch<React.SetStateAction<boolean>>
  mondayAccountId: number
  accessToken: string
}

export const Home: React.FC<HomeProps> = ({ monday, mondayError, setMondayError, mondayAccountId, accessToken }) => {
  const [freshError, setFreshError] = useState<boolean>(false)
  const [mapping, setMapping] = useState<Mapping>()
  const [account, setAccount] = useState<Account>()
  const [navigation, setNavigation] = useState<string>('Home')
  const [currentBoard, setCurrentBoard] = useState<number>()
  const [mappingBoardsLength, setMappingBoardsLength] = useState<number | null>(null)
  const [isUserIsViewOnly, setIsUserIsViewOnly] = useState<boolean>()
  useGetMapping(mondayAccountId, setMapping, accessToken)
  useGetAccount(mapping?.mondayAccountId, setAccount, accessToken, setMondayError)

  const onCheckIfUserViewOnly = useCallback(async () => {
    const isUserIsViewOnly = await mondayService.checkIfUserViewOnly(setMondayError)
    setIsUserIsViewOnly(isUserIsViewOnly)
  }, [setMondayError])

  const loadCurrBoard = useCallback(async (): Promise<void> => {
    monday.listen('context', async (res: any): Promise<void> => {
      const currentBoard: number = res.data.boardIds[0]
      setCurrentBoard(currentBoard)
    })
  }, [monday])

  useEffect(() => {
    onCheckIfUserViewOnly()
    loadCurrBoard()
  }, [onCheckIfUserViewOnly, loadCurrBoard])



  useEffect(() => {
    if (freshError) {
      monday.execute('notice', {
        message: 'Wrong API/Fresh Domain. Please edit your credentials',
        type: 'error',
        timeout: 10000,
      })
      setNavigation('Settings')
    }
  }, [freshError, monday])

  const getMappingBoardsLength = (length: number) => {
    setMappingBoardsLength(length)
  }

  if (isUserIsViewOnly || mondayError) return <ErrorMessage error={'Error occurred. Make sure you have the right permissions on this account.'} />
  else if (!mapping || !account || !currentBoard || !accessToken)
    return (
      <div className="loading">
        <Loader hasBackground />
      </div>
    )
  else if (!mapping.freshApiKey || !mapping.freshDomain) return <FreshAccountForm mapping={mapping} setMapping={setMapping} accessToken={accessToken} />
  else
    return (
      <>
        <Navbar setNavigation={setNavigation} navigation={navigation} account={account} mappingBoardsLength={mappingBoardsLength} />
        <>
          {navigation === 'Home' && <Mapping mapping={mapping} setMapping={setMapping} setFreshError={setFreshError} currentBoard={currentBoard} getMappingBoardsLength={getMappingBoardsLength} accessToken={accessToken} setMondayError={setMondayError} />}
          {navigation === 'Purchase' && <Purchase mondayAccountId={mapping?.mondayAccountId} accessToken={accessToken} setMondayError={setMondayError} />}
          {navigation === 'Settings' && <FreshAccountForm mapping={mapping} setMapping={setMapping} openedFromMapping={true} setNavigation={setNavigation} setFreshError={setFreshError} accessToken={accessToken} />}
          {navigation === 'Help' && <iframe title="howto" src="https://esl-fresh-integration.up.railway.app/howto/" />}
        </>
      </>
    )
}
